module.exports = __webpack_public_path__ + "img/changjing.09fc2371.jpg";